export const serverUrl = {
    // baseURL: '/adminApi/',//测试环境
    baseURL: 'https://api.waterylyh.com/adminApi/',//正式环境
    uploadUrl: 'https://api.waterylyh.com/file/uploadObjectOSS',
    imgUrl: 'https://youlunyihaoonestand.oss-cn-beijing.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js